import apiService from '../apiService';
import { getDeviceTimezone } from '../../utils/dateTime';

export const addTagTypes = ['chat_messages'] as const;

export const chatApi = apiService
	.enhanceEndpoints({
		addTagTypes
	})
	.injectEndpoints({
		endpoints: (build) => ({
			getChatMessages: build.query<any, { address_id: number; page?: number }>({
				query: ({ address_id, page }) => ({
					url: 'chat/messages',
					params: {
						address_id,
						timezone: getDeviceTimezone(),
						pagination: true,
						...(page ? { page } : {})
					}
				}),
				providesTags: ['chat_messages']
			}),
			askChat: build.mutation<
				any,
				{ address_id: number; question: string; document_ids?: number[] }
			>({
				query: ({ address_id, question, document_ids }) => ({
					url: 'chat/ask',
					method: 'POST',
					body: {
						address_id,
						question,
						...(document_ids && document_ids.length > 0 ? { document_ids } : {})
					}
				}),
				invalidatesTags: ['chat_messages']
			})
		}),
		overrideExisting: true
	});

export const { useLazyGetChatMessagesQuery, useAskChatMutation } = chatApi;

